// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import VisaCard from "./VisaCard";
// import VisaInfoSection from "./VisaInfoSection";
// import styles from "./VisaList.module.css";
// import heroImage from "./heroimg.webp";

// // const API_BASE ="https://atlastravelhouse.com";

// // const ENDPOINT = `${API_BASE.replace(/\/$/, "")}/visas/`;
// const API_BASE = "https://atlastravelhouse.com";

// const ENDPOINT = `${API_BASE.replace(/\/$/, "")}/api/visas/`;

// function VisaList() {
//   const [visas, setVisas] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeCategory, setActiveCategory] = useState("visa_required");
//   useEffect(() => {
//     fetchVisas();
//   }, []);

//   const fetchVisas = async () => {
//     try {
//       const response = await axios.get(ENDPOINT);
//       setVisas(response.data);
//     } catch (error) {
//       console.error("Error fetching visas:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredVisas = (
//     activeCategory === "all"
//       ? visas
//       : visas.filter((item) => item.category === activeCategory)
//   ).sort((a, b) => a.country.localeCompare(b.country));

//   if (loading) {
//     return <div className={styles.visaLoading}>Loading visas...</div>;
//   }

//   return (
//     <section className={styles.visaSection}>
//       {/* HERO SECTION */}
//       <div
//         className={styles.visaHero}
//         style={{
//           backgroundImage: `url(${heroImage})`,
//         }}
//       >
//         <div className={styles.visaOverlay}></div>

//         <div className={styles.visaHeroContent}>
//           <h1>Your Gateway to Global Travel</h1>
//           <p>
//             Discover visa requirements, entry rules, and essential travel
//             information for countries worldwide.
//           </p>
//         </div>
//       </div>

//       {/* FILTERS */}
//       <div className={styles.visaFilters}>
//         <button
//           className={`${styles.visaRequiredBtn} ${
//             activeCategory === "visa_required" ? styles.active : ""
//           }`}
//           onClick={() => setActiveCategory("visa_required")}
//         >
//           Visa Required
//         </button>

//         <button
//           className={`${styles.evisaBtn} ${
//             activeCategory === "evisa_voa" ? styles.active : ""
//           }`}
//           onClick={() => setActiveCategory("evisa_voa")}
//         >
//           E-Visa / VOA
//         </button>

//         <button
//           className={`${styles.visaFreeBtn} ${
//             activeCategory === "visa_free" ? styles.active : ""
//           }`}
//           onClick={() => setActiveCategory("visa_free")}
//         >
//           Visa Free
//         </button>
//       </div>

//       <div className={styles.visaGrid}>
//         {filteredVisas.map((visa) => (
//           <VisaCard key={visa.id} visa={visa} />
//         ))}
//       </div>

// <VisaInfoSection />
     
//     </section>
//   );
// }

// export default VisaList;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import VisaCard from "./VisaCard";
// import VisaInfoSection from "./VisaInfoSection";
// import styles from "./VisaList.module.css";
// import heroImage from "./heroimg.webp";

// // const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

// // const ENDPOINT = `${API_BASE.replace(/\/$/, "")}/api/visas/`;
// const API_BASE = "https://atlastravelhouse.com";

// const ENDPOINT = `${API_BASE.replace(/\/$/, "")}/api/visas/`;

// function VisaList() {
//   const [visas, setVisas] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeCategory, setActiveCategory] = useState("visa_required");
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     fetchVisas();
//   }, []);

//   const fetchVisas = async () => {
//     try {
//       const response = await axios.get(ENDPOINT);
//       setVisas(response.data);
//     } catch (error) {
//       console.error("Error fetching visas:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredVisas = visas
//     .filter((visa) => {
//       const matchesSearch = visa.country
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase());

//       if (searchTerm.trim()) {
//         return matchesSearch;
//       }

//       return visa.category === activeCategory;
//     })
//     .sort((a, b) => a.country.localeCompare(b.country));

//   if (loading) {
//     return <div className={styles.visaLoading}>Loading visas...</div>;
//   }
// return (
//   <section className={styles.visaSection}>
//     {/* HERO SECTION */}
//     <div
//       className={styles.visaHero}
//       style={{
//         backgroundImage: `url(${heroImage})`,
//       }}
//     >
//       <div className={styles.visaOverlay}></div>

//       <div className={styles.visaHeroContent}>
//         <h1>Your Gateway to Global Travel</h1>
//         <p>
//           Discover visa requirements, entry rules, and essential travel
//           information for countries worldwide.
//         </p>
//       </div>
//     </div>

//     <div className={styles.searchWrapper}>
//       <div className={styles.searchInputContainer}>
//         <input
//           type="text"
//           placeholder="Search country..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className={styles.searchInput}
//         />

//         {searchTerm && (
//           <button
//             type="button"
//             className={styles.clearSearch}
//             onClick={() => setSearchTerm("")}
//             aria-label="Clear search"
//           >
//             ×
//           </button>
//         )}
//       </div>
//     </div>

//     {searchTerm.trim() && (
//       <p className={styles.searchInfo}>
//         Showing results for "{searchTerm}"
//       </p>
//     )}

//     <div className={styles.visaListingArea}>

//       {!searchTerm.trim() && (
//         <div className={styles.visaFilters}>
//           <button
//             className={`${styles.visaRequiredBtn} ${
//               activeCategory === "visa_required" ? styles.active : ""
//             }`}
//             onClick={() => setActiveCategory("visa_required")}
//           >
//             Visa Required
//           </button>

//           <button
//             className={`${styles.evisaBtn} ${
//               activeCategory === "evisa_voa" ? styles.active : ""
//             }`}
//             onClick={() => setActiveCategory("evisa_voa")}
//           >
//             E-Visa / VOA
//           </button>

//           <button
//             className={`${styles.visaFreeBtn} ${
//               activeCategory === "visa_free" ? styles.active : ""
//             }`}
//             onClick={() => setActiveCategory("visa_free")}
//           >
//             Visa Free
//           </button>
//         </div>
//       )}

//       <div className={styles.visaGrid}>
//         {filteredVisas.length > 0 ? (
//           filteredVisas.map((visa) => (
//             <VisaCard
//               key={visa.id}
//               visa={visa}
//               showCategory={!!searchTerm}
//             />
//           ))
//         ) : (
//           <p className={styles.noResults}>
//             No countries found.
//           </p>
//         )}
//       </div>

//     </div>

//     <VisaInfoSection />
//   </section>
// );

// }


// export default VisaList;




import React, { useEffect, useState } from "react";
import axios from "axios";
import VisaCard from "./VisaCard";
import VisaInfoSection from "./VisaInfoSection";
import styles from "./VisaList.module.css";
import heroImage from "./heroimg.webp";

// const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

// const ENDPOINT = `${API_BASE.replace(/\/$/, "")}/api/visas/`;

const API_BASE = "https://atlastravelhouse.com";

const ENDPOINT = `${API_BASE.replace(/\/$/, "")}/api/visas/`;

// function VisaList() {
  
//   const [visas, setVisas] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeCategory, setActiveCategory] = useState("visa_required");
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     fetchVisas();
//   }, []);
function VisaList() {

  const [visas, setVisas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("visa_required");
  const [searchTerm, setSearchTerm] = useState("");

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const categories = [
    "visa_required",
    "evisa_voa",
    "visa_free",
  ];

  useEffect(() => {
    fetchVisas();
  }, []);
  const fetchVisas = async () => {
    try {
      const response = await axios.get(ENDPOINT);
      setVisas(response.data);
    } catch (error) {
      console.error("Error fetching visas:", error);
    } finally {
      setLoading(false);
    }
  };

  const minSwipeDistance = 50;

const onTouchStart = (e) => {
  setTouchEnd(null);
  setTouchStart(e.targetTouches[0].clientX);
};

const onTouchMove = (e) => {
  setTouchEnd(e.targetTouches[0].clientX);
};

const onTouchEnd = () => {
  if (!touchStart || !touchEnd) return;

  const distance = touchStart - touchEnd;
  const currentIndex = categories.indexOf(activeCategory);

  // Swipe Left
  if (
    distance > minSwipeDistance &&
    currentIndex < categories.length - 1
  ) {
    setActiveCategory(categories[currentIndex + 1]);
  }

  // Swipe Right
  if (
    distance < -minSwipeDistance &&
    currentIndex > 0
  ) {
    setActiveCategory(categories[currentIndex - 1]);
  }
};

  const filteredVisas = visas
    .filter((visa) => {
      const matchesSearch = visa.country
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      if (searchTerm.trim()) {
        return matchesSearch;
      }

      return visa.category === activeCategory;
    })
    .sort((a, b) => a.country.localeCompare(b.country));

  if (loading) {
    return <div className={styles.visaLoading}>Loading visas...</div>;
  }
return (
  <section className={styles.visaSection}>
    {/* HERO SECTION */}
    <div
      className={styles.visaHero}
      style={{
        backgroundImage: `url(${heroImage})`,
      }}
    >
      <div className={styles.visaOverlay}></div>

      <div className={styles.visaHeroContent}>
        <h1>Your Gateway to Global Travel</h1>
        <p>
          Discover visa requirements, entry rules, and essential travel
          information for countries worldwide.
        </p>
      </div>
    </div>

    <div className={styles.searchWrapper}>
      <div className={styles.searchInputContainer}>
        <input
          type="text"
          placeholder="Search country..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />

        {searchTerm && (
          <button
            type="button"
            className={styles.clearSearch}
            onClick={() => setSearchTerm("")}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
    </div>

    {searchTerm.trim() && (
      <p className={styles.searchInfo}>
        Showing results for "{searchTerm}"
      </p>
    )}

    {/* <div className={styles.visaListingArea}> */}
<div
  className={styles.visaListingArea}
  onTouchStart={!searchTerm ? onTouchStart : undefined}
  onTouchMove={!searchTerm ? onTouchMove : undefined}
  onTouchEnd={!searchTerm ? onTouchEnd : undefined}
>
      {!searchTerm.trim() && (
        <div className={styles.visaFilters}>
          <button
            className={`${styles.visaRequiredBtn} ${
              activeCategory === "visa_required" ? styles.active : ""
            }`}
            onClick={() => setActiveCategory("visa_required")}
          >
            Visa Required
          </button>

          <button
            className={`${styles.evisaBtn} ${
              activeCategory === "evisa_voa" ? styles.active : ""
            }`}
            onClick={() => setActiveCategory("evisa_voa")}
          >
            E-Visa / VOA
          </button>

          <button
            className={`${styles.visaFreeBtn} ${
              activeCategory === "visa_free" ? styles.active : ""
            }`}
            onClick={() => setActiveCategory("visa_free")}
          >
            Visa Free
          </button>
        </div>
      )}

      <div className={styles.visaGrid}>
        {filteredVisas.length > 0 ? (
          filteredVisas.map((visa) => (
            <VisaCard
              key={visa.id}
              visa={visa}
              showCategory={!!searchTerm}
            />
          ))
        ) : (
          <p className={styles.noResults}>
            No countries found.
          </p>
        )}
      </div>

    </div>

    <VisaInfoSection />
  </section>
);

}


export default VisaList;